import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// GET ALL
export const GetAll = createAsyncThunk(
  "masters/taluka/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Location?.Taluka}?name=${filter?.name || ""}&country_id=${
          filter?.country_id || ""
        }&state_id=${filter?.state_id || ""}&district_id=${
          filter?.district_id || ""
        }&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//GET SINGLE
export const GetSingle = createAsyncThunk(
  "masters/taluka/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Location?.Taluka}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//CREATE
export const Add = createAsyncThunk(
  "masters/taluka/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Location?.Taluka, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// UPDATE
export const Update = createAsyncThunk(
  "masters/taluka/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.Location?.Taluka}/${id}`,
        data, // send FormData
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//DELETE
export const Delete = createAsyncThunk(
  "masters/taluka/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Location?.Taluka}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// STATUS
export const Status = createAsyncThunk(
  "masters/taluka/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Location?.Taluka}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "taluka",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // GET ALL
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //GET SINGLE
      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //CREATE
      .addCase(Add.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Add.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        //state.data.unshift(action.payload?.data);
      })
      .addCase(Add.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //UPDATE
      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        const updated = action.payload?.data;

        const index = state.data.findIndex((item) => item.id === updated?.id);

        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //DELETE
      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter((item) => item.id !== action.payload);
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //STATUS
      .addCase(Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Status.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        const updated = action.payload?.data;

        const index = state.data.findIndex((item) => item.id === updated?.id);

        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(Status.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
